<template>
  <validation-observer ref="observer" v-slot="{ handleSubmit }">
    <b-form @submit.stop.prevent="handleSubmit(onSubmit)" novalidate>
      <b-row class="mt-3 justify-content-center">
        <b-col md="8">
          <b-card title="Inscrições">
            <p>{{ person.name }}</p>
            <div v-if="!activity ">Não tem incrições abertas</div>
            <div  >
              <h5>Inscrever em: {{ activity.name }}</h5>

              <b-row>
                <b-col md="6">
                  Colocar por ordem:
                  <b-list-group>
                    <b-list-group-item
                      v-for="(item, index) in registration.preferences"
                      :key="item.id"
                    > {{ item.name }} 
                    <span class="float-right">
                     <i v-if="index > 0" @click="moveUp( index)" class="fa fa-arrow-up"></i>
                     <i  v-if="index < registration.preferences.length-1" @click="moveDown(index)" class="fa fa-arrow-down"></i>
                     <i @click="removeFromPrefs(item, index)" class="fa fa-times"></i>
                     </span>
                    </b-list-group-item>
                  </b-list-group>
                </b-col>
                <b-col md="6">
                  Não me quero inscrever em:
                 <b-list-group>
                    <b-list-group-item
                      v-for="(item, index) in unchosen"
                      :key="item.id"
                    >
                     <i @click="addToPrefs(item, index)" class="fa fa-arrow-left"></i> {{ item.name }}
                    </b-list-group-item>
                  </b-list-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="6">
                  <validation-provider
                    name="emergency_contact"
                    :rules="{ required: true }"
                    v-slot="validationContext"
                  >
                    <b-form-group
                      label="Contacto de emergência"
                      label-for="emergency_contact"
                    >
                      <b-form-input
                        name="emergency_contact"
                        v-model="registration.emergency_contact"
                        :state="validateState(validationContext)"
                      ></b-form-input>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <b-col md="6">
                  <validation-provider
                    name="emergency_parent"
                    :rules="{ required: true }"
                    v-slot="validationContext"
                  >
                    <b-form-group
                      label="Parentesco"
                      label-for="emergency_parent"
                    >
                      <b-form-input
                        name="emergency_parent"
                        v-model="registration.emergency_parent"
                        :state="validateState(validationContext)"
                      ></b-form-input>
                    </b-form-group>
                  </validation-provider>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="6">
                  <b-form-group label="Sabe nadar?">
                    <validation-provider
                    name="can_swim"
                    :rules="{ required: true }"
                    v-slot="validationContext"
                  >
                    <b-form-select name="can_swim" v-model="registration.can_swim" 
                            :options="yesNoOptions" class="mb-3" :state="validateState(validationContext)"></b-form-select>                  
                            
                  </validation-provider>
                  </b-form-group>
                </b-col> 
              </b-row>
              <b-row>
                <b-col md="6">
                  <b-form-group label="Toma medicação?">
                    <validation-provider
                    name="medication"
                    :rules="{ required: true }"
                    v-slot="validationContext"
                  >
                    <b-form-select name="medication" v-model="registration.medication" 
                            :options="yesNoOptions" class="mb-3" :state="validateState(validationContext)"></b-form-select>                  
                            
                  </validation-provider>
                  </b-form-group>
                </b-col> 
                <b-col>
                  <b-form-group label="Quais?" v-if="registration.medication == 1">
                    <validation-provider
                      name="medication_details"
                      :rules="{ required: true }"
                      v-slot="validationContext"
                    >
                      <b-form-textarea name="medication_details" v-model="registration.medication_details" 
                              :options="yesNoOptions" class="mb-3" :state="validateState(validationContext)"></b-form-textarea>                  
                              
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="6">
                  <b-form-group label="Tem alergias?">
                    <validation-provider
                    name="alergic"
                    :rules="{ required: true }"
                    v-slot="validationContext"
                  >
                    <b-form-select name="alergic" v-model="registration.alergic" 
                            :options="yesNoOptions" class="mb-3" :state="validateState(validationContext)"></b-form-select>                  
                            
                  </validation-provider>
                  </b-form-group>
                </b-col> 
                <b-col>
                  <b-form-group label="Quais?" v-if="registration.alergic == 1">
                    <validation-provider
                      name="alergic_details"
                      :rules="{ required: true }"
                      v-slot="validationContext"
                    >
                      <b-form-textarea name="alergic_details" v-model="registration.alergic_details" 
                              :options="yesNoOptions" class="mb-3" :state="validateState(validationContext)"></b-form-textarea>                  
                              
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>
              <p>
                <label for='terms'>
                  <input id='terms' type='checkbox' v-model="checked" /> Li a Carta Pais sobre os Campos de Verão de 2021 (disponível no rodapé desta página)
                </label>
              </p>
              <b-btn @click="$router.go(-1)" variant="primary">Voltar</b-btn> {{working}}
              <b-btn :disabled='!checked || working' type="submit" variant="primary" style="margin-left:10px">Inscrever</b-btn>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </b-form>
  </validation-observer>
</template>


<script>
export default {
  name: "LoginForm",
  data() {
    return {
      checked : false,
      working: false,
      person: {},
      activity: [],
      unchosen: [],
      registration: {
        preferences: [],      
      },
      yesNoOptions: [
            { text: "Sim", value: 1, disabled: false },
            { text: "Não", value: 0, disabled: false },
        ],
    };
  },
  methods: {
    validateState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    addToPrefs(item, index) {
      this.unchosen.splice(index, 1)
      this.registration.preferences.push(item)
    },
    removeFromPrefs(item, index) {
      this.registration.preferences.splice(index, 1)
      this.unchosen.push(item)
    },
    moveUp(index) {
      this.moveItem(index, index-1)
    },
    moveDown(index) {
      this.moveItem(index, index+1)
    },
    moveItem(from, to) {
      // remove `from` item and store it
      var f = this.registration.preferences.splice(from, 1)[0];
      // insert stored item into position `to`
      this.registration.preferences.splice(to, 0, f);
    },
    onSubmit()  {
      if(this.registration.preferences.length == 0) {
         this.$bvToast.toast('Tem de escolher pelo menos um campo', { autoHideDelay: 5000, variant: 'danger', solid: true})
        return;
      }
      let data = {
        registration: this.registration,
        person: this.person
      }
      this.working = true
      this.axios.post("front/registration", data)
        .then(response => {
           this.item = response.data.data
           this.working = false
           //this.$bvToast.toast('item gravado com sucesso', { autoHideDelay: 5000, variant: 'success', solid: true})
           //this.$root.$bvToast.toast('item gravado com sucesso', { autoHideDelay: 5000, variant: 'success', solid: true})
           this.$router.push({
              name: 'view_registration',
              params: { 
                personId: this.$route.params.personId, 
                activityId: this.$route.params.activityId,
                message: true 
              }
              // params: {
              //   id: this.item.id
              // }
            })

        })
        .catch(response => {
            console.log(response.data.data)
            this.$bvToast.toast('Não foi possivel gravar', { autoHideDelay: 5000, variant: 'danger', solid: true})
          })
    }
  },
  created() {
    let id = this.$route.params.personId;
    let activityId = this.$route.params.activityId;
    this.axios.get("front/familymember/" + id).then((response) => {
      this.person = response.data.data;
    });
    this.axios.get("front/registrations/" + id + '/' + activityId).then((response) => {
      this.activity = response.data.data;
      this.registration.activity_id = activityId;
      this.registration.activity_year_id = this.activity.year?.data.id;
      this.unchosen = this.activity.subactivities.data
    });
  },
};
</script>